export const G_LOGIN_START = "G_LOGIN_START"
export const G_LOGIN_SUCCESS = "G_LOGIN_SUCCESS"
export const G_LOGIN_ERROR = "G_LOGIN_ERROR"
export const G_LOGIN_RESET= "G_LOGIN_RESET"
